var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRocket = function SvgRocket(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5194 9.34142C14.9219 9.29669 15.323 9.43738 15.6094 9.72379L22.2761 16.3905C22.5625 16.6769 22.7032 17.0779 22.6585 17.4805L21.3251 29.4805C21.2685 29.9899 20.9249 30.4218 20.4413 30.5914C19.9576 30.7611 19.4196 30.6385 19.0571 30.2761L1.72381 12.9427C1.36139 12.5803 1.2388 12.0422 1.40845 11.5586C1.57811 11.0749 2.00998 10.7313 2.51938 10.6747L14.5194 9.34142ZM5.57106 13.0187L18.9811 26.4288L19.9373 17.8229L14.177 12.0625L5.57106 13.0187Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 23.9998L8 18.6665L18.8 4.2665C19.5554 3.25928 20.741 2.6665 22 2.6665H29.3333V9.99984C29.3333 11.2589 28.7406 12.4444 27.7333 13.1998L13.3333 23.9998Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9999 3.99992C21.1605 3.99992 20.3701 4.3951 19.8665 5.06659L9.76035 18.5415L13.4583 22.2394L26.9332 12.1333C27.6047 11.6296 27.9999 10.8393 27.9999 9.99992V3.99992H21.9999ZM17.7332 3.46659C18.7404 2.12362 20.3211 1.33325 21.9999 1.33325H29.3332C30.0696 1.33325 30.6665 1.93021 30.6665 2.66659V9.99992C30.6665 11.6786 29.8762 13.2594 28.5332 14.2666L14.1332 25.0666C13.6024 25.4647 12.8596 25.4119 12.3904 24.9427L7.05704 19.6094C6.58785 19.1402 6.53506 18.3974 6.93318 17.8666L17.7332 3.46659Z",
    fill: "#8290A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 25.3332C4.59687 25.3332 3.99992 25.9301 3.99992 26.6665V27.9998H5.33325C6.06963 27.9998 6.66658 27.4029 6.66658 26.6665C6.66658 25.9301 6.06963 25.3332 5.33325 25.3332ZM1.33325 26.6665C1.33325 24.4574 3.12411 22.6665 5.33325 22.6665C7.54239 22.6665 9.33325 24.4574 9.33325 26.6665C9.33325 28.8756 7.54239 30.6665 5.33325 30.6665H2.66659C1.93021 30.6665 1.33325 30.0696 1.33325 29.3332V26.6665Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocket.cb849f4a.svg";
export { ForwardRef as ReactComponent };